import React, { useState, useEffect } from "react";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";

import { useHistory } from "react-router";

import axios from "axios";

import "../App.css";

// import { app } from '../App';
// import firebase from "firebase/app";
// import "firebase/auth";

import { auth } from "../App";

function SignUp() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [reenterPassword, setReenterPassword] = useState("");
  const [name, setName] = useState("");
  const [passwordsEquals, setPasswordEquals] = useState("true");
  const history = useHistory();

  const changeEmail = (e) => {
    setEmail(e.target.value);
  };

  const changePassword = (e) => {
    setPassword(e.target.value);
  };

  const changeReenterPassword = (e) => {
    setReenterPassword(e.target.value);
  };

  const changeName = (e) => {
    setName(e.target.value);
  };

  useEffect(() => {
    console.log("kontroluje hesla");
    if (password === reenterPassword) {
      setPasswordEquals("true");
    } else {
      setPasswordEquals("false");
    }
  }, [password, reenterPassword]);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (passwordsEquals === "true") {
      auth
        .createUserWithEmailAndPassword(email, password)
        .then((user) => {
          auth.currentUser
            .updateProfile({
              displayName: name,
            })
            .then(function () {
              return user;
            })
            .then((user) => {
              axios
                .post("/addUserToDB", user)
                .then(function (response) {
                  console.log(response);
                })
                .catch(function (error) {
                  console.log(error);
                });
              history.push("/home");
            })
            .catch(function (error) {
              // An error happened.
            });
          // localStorage.setItem("user", user.user.uid);
          console.log(user);
          return user;
        })

        .catch((error) => {
          console.log(error);
        });
    }
  };

  return (
    <Grid container>
      <Grid item sm />
      <Grid item sm>
        <Typography variant="h2"> Sign Up </Typography>{" "}
        <form onSubmit={handleSubmit}>
          <TextField
            id="Name"
            label="Name"
            type="text"
            onChange={changeName}
            fullWidth
          />
          <TextField
            id="Email"
            label="Email"
            type="email"
            onChange={changeEmail}
            fullWidth
          />
          <TextField
            id="Password"
            label="Password"
            type="password"
            onChange={changePassword}
            fullWidth
          />
          <TextField
            id="ReenterPassword"
            label="Reenter password"
            type="password"
            onChange={changeReenterPassword}
            fullWidth
          />
          {passwordsEquals === "false" && (
            <div className="loginSignUpError">
              {" "}
              Password and reentered password do not match.{" "}
            </div>
          )}
          <div className="loginSignUpButton">
            <Button type="submit" variant="contained" color="primary">
              Sign Up{" "}
            </Button>{" "}
          </div>{" "}
        </form>{" "}
      </Grid>{" "}
      <Grid item sm />
    </Grid>
  );
}

export default SignUp;
